import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import InquiryBox from '../../components/admin/InquiryBox'
import CurriculumLayout from '../../components/layout/CurriculumLayout'

const Inquiries = () => {
  return (
    <AdminLayout>
      <AdminContentLayout>
        <CurriculumLayout title={'Inquiries'}>
          <InquiryBox />
        </CurriculumLayout>
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default Inquiries
